<template>
    <div class="upload-container" v-bind:class="className">
        <slot name="content"></slot>
        <drop-zone />
    </div>
</template>

<script>
    import DropZone from "./DropZone";
    export default {
        name: "Container",
        props: {
            className: String
        },
        components: {
            DropZone
        },
        methods: {
            prevent: function(e) {
                e.preventDefault();
                e.stopPropagation();
            },
            dragUploadEnter: function() {
                $(this.$el).find(".drop-zone").addClass("dragging-from-container");
            },
            dragUploadLeave: function() {
                $(this.$el).find(".drop-zone").removeClass("dragging-from-container");
            }
        },
        mounted: function() {
            // Upload form visibility
            $(this.$el)
                .on("drag dragstart dragend dragover dragenter dragleave drop", this.prevent)
                .on("dragover dragenter", this.dragUploadEnter.bind(this))
                .on("dragleave dragend drop", this.dragUploadLeave.bind(this));
        },
        beforeDestroy: function() {
            $(this.$el).off("drag dragstart dragend dragover dragenter dragleave drop");
        }
    }
</script>
